import React from 'react';
import Select from 'react-select';
import './styles.css';
function FilterComponent({ options, onChange, value, title, placeholder }) {
  const defaultValue = (options, value) => {
    return options ? options.find((option) => option.value === value) : '';
  };

  return (
    <div>
      <Select
        options={options}
        classNamePrefix='react-select'
        placeholder={placeholder}
        onChange={(value) => onChange(value.value)}
        isSearchable={true}
        value={defaultValue(options, value)}
      />
      <p className='filter-title'>{title}</p>
    </div>
  );
}

export default FilterComponent;
